export default class NotificationManager 
{

	constructor() 
	{
		this.MIN_DATE = new Date(1970, 1, 1);
		this.MAX_DATE = new Date(2500, 1, 1);
		this.ONE_HUNDRED = 100;
		this.TEN_MINUTES = 600000;
		this.HALF_AN_HOUR = 1800000;
		this.dateFrom = this.MIN_DATE;
		this.dateTo = this.MAX_DATE;
		this.firstCall = true;
		this.lastNotificationDate = null;
		this.notificationList= [];
		this.INTERVAL_RELOAD_FOR_ACTIVE_USER = 30000;
		this.INTERVAL_RELOAD_FOR_INACTIVE_USER = 300000;
		this.timerTimeOut = null;
		this.notificacionTimeOut = null;
		this.scrollHeight = null;
		this.inactivityTime = null;
		this.timeOutCall = null;
		this.REPORTS_TAG = "reports";
		this.isBoxofficeMode = typeof boxOfficeConfiguration != "undefined";
	}

	timer(timerTimeOut) 
	{
		if(this.timeOutCall != null) clearTimeout(this.timeOutCall);
		this.inactivityTime = inactivityManager.getInactivityTime();
		if(this.inactivityTime > this.HALF_AN_HOUR)
		{
			this.timeOutCall = setTimeout(()=>{
				this.loadNewNotifications();
			}, this.TEN_MINUTES);
		}
		else
		{
			this.timerTimeOut = timerTimeOut != null ? timerTimeOut : this.inactivityTime < this.TEN_MINUTES
			? this.INTERVAL_RELOAD_FOR_ACTIVE_USER
			: this.INTERVAL_RELOAD_FOR_INACTIVE_USER;
			this.timeOutCall = setTimeout(() => {
				BackofficeAjax.getNotifications(this.dateFrom, null, (notifications) => this.onLoadNotifications(notifications, true));
			}, this.timerTimeOut);
		}
	}

	loadNewNotifications() 
	{	
		if (this.firstCall) 
		{
			let notificationsOnStorage = JSON.parse(localStorage.getItem("backoffice_notifications"));
			if(notificationsOnStorage != null)
			{
				this.notificationList = notificationsOnStorage;
				if (this.notificationList.length > this.ONE_HUNDRED) 
				{
					this.orderNotificationsByDate();
					this.notificationList = this.notificationList.slice(0, this.ONE_HUNDRED);
				}
				this.processWithNotifications();
			}
			else
			{
				this.loadOldNotifications();
			}
		}
		else 
		{
			this.timer(null);
		}
	}

	loadOldNotifications() 
	{
		BackofficeAjax.getNotifications(null, this.dateTo, (notifications) => this.onLoadNotifications(notifications, false));
	}

	makePopup(notifications) 
	{
		for (let i = 0; i < notifications.length; i++) 
		{
			let ntf = notifications[i];
			if (ntf.status == NotificationStatus.IN_PROGRESS_STATUS) 
			{
				loadNotification([ntf.startTitle, ntf.startDescription], "waiting", 5000);
			}
			else if (ntf.status == NotificationStatus.ERROR_STATUS) 
			{
				loadNotification([ntf.endTitle, ntf.endDescription], "notification-error", 5000);
			}
			else 
			{
				loadNotification([ntf.endTitle, ntf.endDescription], "notification", 5000);
			}
		}
		
		if(!this.isBoxofficeMode)
		{
			document.getElementById('notification-tittle-bubble').style.display = "block";
			document.getElementById('header-notification-bubble').style.display = "block";
		}
	}

	onLoadNotifications(notifications, isForNewNotifications) 
	{
		let panelIsOpen = !this.isBoxofficeMode && $('#vNotifications').is(":visible");
		let notificationsHaveContent = notifications != null && notifications.length > 0; 
		let notificationListHaveContent = this.notificationList != null && this.notificationList.length > 0; 
		let notificationFooter = this.isBoxofficeMode ? null : document.getElementById('notifications-panel-footer');
		
		if(notificationFooter != null && !notificationsHaveContent && !notificationListHaveContent)
		{
			notificationFooter.style.display = "none";
			return;	
		}
		
		if(notificationFooter != null && notificationFooter.style.display == "none")
		{
			notificationFooter.style.display = "block"; 
		}

		let isAllNotificationsRead = (!notificationsHaveContent || notifications.filter(ntf => ntf.readingDate == null).length == 0) && this.notificationList.filter(ntf => ntf.readingDate == null).length == 0; 
		
		let notificationsContainer = document.getElementById('wrapper-panels').parentElement.parentElement;
		if(document.getElementById('notification-tittle-bubble') != null)
		{
			document.getElementById('notification-tittle-bubble').style.display = isAllNotificationsRead ? "none" : "block";
		}
		
		if(document.getElementById('header-notification-bubble') != null)
		{
			document.getElementById('header-notification-bubble').style.display = isAllNotificationsRead ? "none" : "block";
		}	

		if(!notificationListHaveContent)
		{
			this.notificationList = notifications;
		}

		let secondNotification = null;
		let newNotificationHeight = 0;
		if(!this.isBoxofficeMode && !this.firstCall && this.notificationList.length > 1)
		{
			secondNotification = document.getElementById('notification_' + this.notificationList[1].idNotification).firstElementChild.firstElementChild;
			newNotificationHeight = secondNotification.offsetHeight;
		}
		
		if(!this.isBoxofficeMode && !isForNewNotifications)
		{
			if(!notificationsHaveContent)
			{
				alertaExcepcion(null, polyglot.t("notifications.you_dont_have_older_notifications"));
				document.getElementById('load-notifications-btn').disabled = true;
				return;
			}
			else if(notifications.length < 20)
			{
				this.scrollHeight = notificationsContainer.scrollHeight;
			}
		}

		if(notificationsHaveContent)
		{
			let listNotificationsIds = this.notificationList.map(ntf => ntf.idNotification);
			let newNotifications = [];

			notifications.forEach(ntf =>  {
				let posNotification = listNotificationsIds.indexOf(ntf.idNotification); 
				if(posNotification !== -1)
				{
					let hasUpdate = this.notificationList[posNotification].endDate == null && ntf.endDate !=null;
					if(hasUpdate) 
					{
						ntf.readingDate = null;
						newNotifications.push(ntf);
					}
					this.notificationList[posNotification] = ntf;
				}
				else
				{
					newNotifications.push(ntf);
					this.notificationList.push(ntf);
				}
			});

			if(newNotifications != null && newNotifications.length > 0 && (isForNewNotifications || this.firstCall)) 
			{
				if(panelIsOpen && typeof boxOfficeConfiguration == "undefined")
				{
					if(newNotificationHeight < notificationsContainer.scrollTop)
					{
						this.showNewNotificationBubble();
					}
				}
				else
				{
					this.makePopup(newNotifications);
				}
			}
		}

		if(this.notificationList != null && this.notificationList.length > 0)
		{
			this.processWithNotifications();	
		
			if(!this.isBoxofficeMode && panelIsOpen)
			{			
				if(!isForNewNotifications)
				{
					notificationsContainer.scrollTo({ top: this.scrollHeight, behavior: 'smooth' });
				}
				notificationsHaveContent && this.markNotificationsAsRead();
			}
		}
	}
	
	showNewNotificationBubble()
	{
		const NEW_NOTIFICATION_BUBBLE = document.getElementById('new-notification-bubble');
		NEW_NOTIFICATION_BUBBLE.style.display = "block";
		NEW_NOTIFICATION_BUBBLE.addEventListener("click", () => this.closeNewNotificationBubble(true));
	}
	
	closeNewNotificationBubble(scroll)
	{
		if(scroll)
		{
			let notificationsContainer = document.getElementById('wrapper-panels').parentElement.parentElement;
			notificationsContainer.scrollTo({top: 0, behavior: 'smooth'});
		}
		const NEW_NOTIFICATION_BUBBLE = document.getElementById('new-notification-bubble');
		NEW_NOTIFICATION_BUBBLE.style.display = "none";
		NEW_NOTIFICATION_BUBBLE.removeEventListener("click", ()=>{});
	}
	
	processWithNotifications()
	{
		this.orderNotificationsByDate();
		this.dateFrom = this.notificationList[0].notificationDate;
		this.dateTo = this.notificationList[this.notificationList.length - 1].notificationDate;
		
		if(!this.isBoxofficeMode)
		{
			if(!this.firstCall)
			{
				let notificacionsPanel = document.getElementById('wrapper-panels').parentElement.parentElement; 
				let notificacionsPanelFirstChildHeight = document.getElementById('vNotifications').firstElementChild.clientHeight;
				let notificacionsPanelLastChildHeight = document.getElementById('vNotifications').lastElementChild.clientHeight;
				this.scrollHeight = notificacionsPanel.scrollHeight - notificacionsPanelFirstChildHeight - notificacionsPanelLastChildHeight;
			}
			
			this.renderNotifications();
		}
		
		localStorage.setItem("backoffice_notifications", JSON.stringify(this.notificationList));
		this.firstCall = false;
		this.loadNewNotifications();
	}

	renderNotifications() 
	{
		let notificationsToRender = this.getNotificatiosToRender();
		let notificationHtml = "";
		for (let i = 0; i < notificationsToRender.length; i++) {
			notificationHtml += this.getNotificationsHtml(notificationsToRender[i]);
		}

		let notificationsContainer = document.getElementById('notifications-container');

		notificationsContainer.innerHTML = notificationHtml;
	}

	getNotificatiosToRender()
	{
		let notificationsToRender = JSON.parse(JSON.stringify(this.notificationList));
		this.notificationList.forEach(ntf => {
			if(ntf.startDate != null && ntf.endDate != null)
			{
				let notificationStart = JSON.parse(JSON.stringify((ntf)));
				notificationStart.notificationDate = ntf.startDate;
				notificationStart.endDate = null;
				notificationStart.status = NotificationStatus.START_STATUS;
				notificationStart.idNotification = -ntf.idNotification;
				notificationsToRender.push(notificationStart);
			}
		});
		return notificationsToRender.sort((a, b) => b.notificationDate - a.notificationDate);
	}

	getNotificationsHtml(notification) 
	{
		let notificationDateFormated = formatDate(new Date(notification.notificationDate).valueOf());
		let notificationHtml = "";
		if(notificationDateFormated !== this.lastNotificationDate)
		{
			this.lastNotificationDate = notificationDateFormated;
			let isToday = notificationDateFormated == formatDate(new Date().valueOf()); 
			let isYesterday = notificationDateFormated == formatDate(new Date().valueOf() - 24*60*60*1000);
			notificationHtml = "<div class='notifications-date'><div class='large-12 columns'><div class='notifications-date--day'><p>" + (isToday ? polyglot.t('Today') : isYesterday ? polyglot.t('Yesterday') : notificationDateFormated) + "</p></div></div></div>";
		}
		
		notificationHtml += "<div id='notification_" + notification.idNotification + "' class='notification-wrapper'><div class='large-12 columns'><div class='row notification'><div class='notification-tags'>";

		if (notification.status == NotificationStatus.ERROR_STATUS) 
		{
			notificationHtml += "<div class='notification-tag error'><p>" + polyglot.t('notifications.error') + "</p></div>";
		}
		else if (notification.status == NotificationStatus.IN_PROGRESS_STATUS) 
		{
			notificationHtml += "<div class='notification-tag in-progress'><p>" + polyglot.t('notifications.in_progress') + "</p></div>";
		}
		else if (notification.status == NotificationStatus.START_STATUS) 
		{
			notificationHtml += "<div class='notification-tag start'><p>" + polyglot.t('notifications.start') + "</p></div>";
		}
		else 
		{
			notificationHtml += "<div class='notification-tag done'><p>" + polyglot.t('notifications.done') + "</p></div>";
		}
		
		notificationHtml += "<div class='notification-tag " + notification.tag + "'><p>" + polyglot.t(NotificationTagsTranslations[notification.tag]) + "</p></div>";
		if(notification.idUser == 0)
		{
			let info = notification.idVenue != 0 ? "Venue" : "Company";
			notificationHtml += "<div class='notification-tag group'><p>" + info + "</p></div>";
		}
		
		let idNotification = notification.idNotification.toString();
		idNotification = idNotification.charAt(0) == "-" ? idNotification.slice(1) : idNotification;
		notificationHtml += "<div class='notification-tag' style='border: 1px solid #0000001f;'><p>id: " + idNotification + "</p></div>";
		notificationHtml += "</div>";

		if (notification.readingDate == null) 
		{
			document.getElementById('notification-tittle-bubble').style.display = "block";
			if (document.getElementById('header-notification-bubble') != null)
			{
							document.getElementById('header-notification-bubble').style.display = "block";
			}

			if(notification.status !== NotificationStatus.START_STATUS)
			{
				notificationHtml += "<div class='notification-bubble'></div>";
			}
		}

		let date = new Date(notification.notificationDate);
		let notificationDate = formatTime(date);
		let isInProgressNotification = notification.status == NotificationStatus.IN_PROGRESS_STATUS || notification.status == NotificationStatus.START_STATUS
		let notificationTitle = isInProgressNotification ? notification.startTitle : notification.endTitle;
		let notificationDescription = isInProgressNotification ? notification.startDescription : notification.endDescription;

		notificationHtml += "<div class='notification-info'><div class='notification-message'><p>" + notificationTitle  + "</p><p>" + notificationDescription  + "</p></div><div class='notification-time'><p>" + notificationDate + "</p></div></div>";

		if (notification.url != null && notification.status == NotificationStatus.DONE_STATUS) 
		{
			notificationHtml +=  notification.tag == this.REPORTS_TAG 
			? "<div class='notification-link'><a target='_blank' href='" + notification.url + "'>" + notification.urlDescription + " <i class='palco4icon palco4icon-open-in-new'></i></a></div>"
			: "<div class='notification-link'><a href='" + notification.url + "'>" + notification.urlDescription + " <i class='palco4icon palco4icon-open-in-new'></i></a></div>";
		}

		notificationHtml += "</div></div></div>";

		return notificationHtml;
	}

	markNotificationsAsRead()
	{
		if(this.notificationList == null || this.notificationList.length == 0)
		{
			document.getElementById('notifications-container').innerHTML = "<div class='notifications-date--day no-notifications'><i class='palco4icon palco4icon-notifications-active'></i>" + polyglot.t('notifications.you_dont_have_notifications_yet') + "</div>";
		}
		else
		{
			this.notificacionTimeOut = setTimeout(()=>{
				let unReadNotifications = this.notificationList.filter(ntf => ntf.readingDate == null);
				if(unReadNotifications != null && unReadNotifications.length > 0)
				{
					BackofficeAjax.markNotificationsAsRead(unReadNotifications, (notifications)=> this.onReadNotifications(notifications));
				}
			}, 3000);
		}
	}

	onReadNotifications(notifications)
	{
		let notificationsIds = notifications.map(ntf => ntf.idNotification);
		this.notificationList.forEach(ntf => { if(notificationsIds.indexOf(ntf.idNotification) != -1) ntf.readingDate = new Date().getTime(); } );
		localStorage.setItem("backoffice_notifications", JSON.stringify(this.notificationList));
	}

	cancelNotificationTimeOut()
	{
		if(this.notificacionTimeOut != null)
		{
			clearTimeout(this.notificacionTimeOut);
		}
	}

	orderNotificationsByDate()
	{
		this.notificationList = this.notificationList.sort((a, b) => b.notificationDate - a.notificationDate);
	}
}